import queryString from 'querystring';

import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";


// let redux = reduxCreator.type('DATING_TOPICS').plugin(axiosPlugin);
let redux = reduxCreator.type('DATING_TOPICS').plugin(axiosPlugin, {template: "array"});

let fetchDatingTopicsAction = redux.fetchActionGet();

export const fetchDatingTopics = (query = {}) => {
    if(query.sortBy){
        query.sort = query.sortBy;
        delete query.sortBy;
    }
    return fetchDatingTopicsAction(`/topics?${queryString.stringify(query)}`)
};
export const resetDatingTopics = () => redux.actions.reset();

export const datingTopics = redux.reducer();



